<script>
import { cloneDeep, sortBy } from "lodash";
import RawData from "@/components/widgets/raw-data.vue";
export default {
    data(){
        return{
            pendingLoading: false,
            pendingData: [],
            approvedLoading: false,
            approvedData: [],
            filterPending: "",
            perPagePending: 10,
            currentPendingPage: 1,
            filterApproved: "",
            perPageApproved: 10,
            currentApprovedPage: 1,
            selectedIndex: null,
            approvedLoaded: false,
            uploadOptions: {
                type: "Bids & Quotations",
                placement: "lefttop",
                folder: "Procurement",
            },
        }
    },
    components: {
        RawData,
    },
    computed: {
        filteredPending(){
            let data = this.pendingData;
            var total = this.currentPendingPage * this.perPagePending;
            if (this.filterPending.trim() != "" && this.filterPending) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterPending.toUpperCase());
                });
            }
            data = data.slice(total - this.perPagePending, total);
            return data;
        },
        filteredApproved(){
            let data = this.approvedData;
            var total = this.currentApprovedPage * this.perPageApproved;
            if (this.filterApproved.trim() != "" && this.filterApproved) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterApproved.toUpperCase());
                });
            }
            data = data.slice(total - this.perPageApproved, total);
            return data;
        },
    },
    methods:{
        async getUnits() {
            await this.$store
            .dispatch("unit/GetUnit")
                .then((res) => {
                    this.units = res.data;
                })
                .catch(() => {
                    this.showToast(
                        "Something went wrong - getting units",
                        "error"
                    );
                });
        },
        async getPendingData() {
            if(this.pendingData.length == 0){
                this.pendingLoading = true;
                this.pendingData = []
                await this.$store.dispatch("rfqbacsetting/GetPendingBAC")
                    .then((response) => {
                        if(response.data.error){
                            return this.showToast(response.data.errorMessage, 'error')
                        }
                        response.data.forEach(item => {
                            item.searchKey = item.rfqNumber + ' ' + item.description;
                            item.rfqItems = [];
                            item.visible = false;
                            item.supplierShow = false;
                            item.detailShow = true;
                            item.rfqSuppliers = [];
                            item.itemVisible = false;
                            item.itemLoaded = false;
                            item.itemLoading = false;
                            item.rfqItemLoading = false;
                            item.rfqItemLoaded = false;
                            item.attachmentVisible = false
                            item.memberLoading = false;
                            item.rfqFiles = [];
                            item.rfqBacSettings = []
                            item.fileSearch = "";
                            item.attachmentLoading = true;
                            item.addDocu = false;
                            item.memberVisible = false;
                            item.supplierLoading = false;
                        })
                        this.pendingData = response.data;
                        this.$emit('countPending', this.pendingData.length)
                    })
                    .catch((error) => {
                        console.log(error)
                        this.showToast('Something went wrong', 'error')
                    });
                this.pendingLoading = false;
            }
        },
        async getApprovedData() {
            if (!this.approvedLoaded) {
                this.approvedLoading = true;
                await this.$store.dispatch("rfqbacsetting/GetApprovedBAC")
                    .then((response) => {
                        response.data.forEach(item => {
                            item.searchKey = item.rfqNumber + ' ' + item.description;
                            item.visible = false;
                            item.rfqItems = [];
                            item.supplierShow = false;
                            item.detailShow = true;
                            item.rfqSuppliers = [];
                            item.itemVisible = false;
                            item.itemLoaded = false;
                            item.itemLoading = false;
                            item.rfqItemLoading = false;
                            item.rfqItemLoaded = false;
                            item.attachmentVisible = false;
                            item.memberLoading = false;
                            item.rfqFiles = [];
                            item.rfqBacSettings = []
                            item.fileSearch = "";
                            item.attachmentLoading = true;
                            item.addDocu = false;
                            item.memberVisible = false;
                            item.supplierLoading = false;
                        })
                        this.approvedData = response.data;
                    })
                    .catch((error) => {
                        this.showToast('Something went wrong', 'error')
                    });
                this.approvedLoading = false;
                this.approvedLoaded = true;
            }
        },
        getTotalPerPR(prItems) {
            return prItems.reduce((pv, cv) => {
                return pv + parseFloat(cv.total);
            }, 0);
        },
        async fetchRfqItems(x){
            await this.$store
                .dispatch("rfqitem/GetRfqItems", x.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(
                            res.data.errorMessage,
                            "error"
                        );
                    }
                    res.data.forEach((x) => {
                        x.sortName = x.itemName.trim().toLowerCase();
                        x.sortDescription = x.description.trim().toLowerCase();
                        x.total = parseFloat(x.unitCost) * parseFloat(x.quantity);

                    });
                    x.rfqItems = sortBy(res.data, ['sortName', 'sortDescription']);
                    x.rfqItemLoaded = true;
                })
                .catch((err) => {
                    x.rfqItemLoading = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        async getRfqItems(x){
            x.itemVisible = !x.itemVisible;
            if(x.itemVisible && !x.rfqItemLoaded){
                x.rfqItemLoading = true;
                await this.fetchRfqItems(x)
                x.rfqItemLoading = false;
            }
        },
        async getBACMembers(x){
            x.memberVisible = !x.memberVisible;
            if(x.memberVisible){
                x.memberLoading = true;
                await this.$store
                    .dispatch("rfqbacsetting/GetRfqBacSetting", x.id)
                    .then((res) => {
                        x.memberLoading = false;
                        if (res.data.error) {
                            return this.showToast(
                                res.data.errorMessage,
                                "error"
                            );
                        }
                        x.rfqBacSettings = res.data;
                    })
                    .catch((err) => {
                        x.memberLoading = false;
                        this.showToast("Something went wrong!", "error");
                    });
            }
        },
        async getRfqSupplier(x) {
            x.supplierShow = !x.supplierShow;
            if (x.supplierShow && !x.itemLoaded) {
                x.supplierLoading = true;
                if(x.rfqItems.length == 0){
                    await this.fetchRfqItems(x)
                }
                await this.$store
                    .dispatch("rfqsupplier/GetSingleRfqSupplierByRFQ", x.id)
                    .then((res) => {
                        x.supplierLoading = false;
                        if (res.data.error) {
                            return this.showToast(
                                res.data.errorMessage,
                                "error"
                            );
                        }
                        res.data.forEach((z) => {
                            var rfqItems = cloneDeep(x.rfqItems);
                            z.isWinner = false;
                            z.rfqSupplierOffers.map(offer => {
                                offer.unit = this.units.find((a) => a.id == offer.unitId) || {};
                            })
                            rfqItems.forEach((w) => {
                                let offer = z.rfqSupplierOffers.find((a) => a.rfqItemId == w.id);
                                if (offer) {
                                    offer.unit = this.units.find((a) => a.id == offer.unitId) || {};
                                    offer.totalAmt = parseFloat(offer.unitCost) * parseFloat(offer.quantity);
                                    offer.showMoreSpec = false;
                                    if(offer.isWinner){
                                        z.isWinner = true;
                                    }
                                }
                            });
                            z.supplierRFQ = rfqItems;
                            z.visible = false;
                        });
                        x.itemLoaded = true;
                        x.rfqSuppliers = res.data;
                    })
                    .catch((err) => {
                        console.log(err)
                        this.showToast("RFQ Item went wrong!", "error");
                    });
            }
        },
        getTotalOffer(data) {
            return data.reduce((pv, cv) => {
                return pv + parseFloat(cv.total);
            }, 0);
        },
        approveAOQ(row){
            this.$emit("approveAOQ", {row: row, type: 'aoq'});
        },
        approvedDone(id){
            let index = this.pendingData.findIndex(x => x.id == id);
            this.approvedData.push(this.pendingData[index]);
            this.pendingData.splice(index, 1);
            let dashboardData = JSON.parse(localStorage.getItem("dashboardData"));
            dashboardData.needBacApproval = dashboardData.needBacApproval - 1;
            localStorage.setItem("dashboardData", JSON.stringify(dashboardData));
            this.attachedDUNotifications();
            this.$emit('countPending', this.pendingData.length)
        },
        getAttachments(row) {
            row.attachmentVisible = !row.attachmentVisible;
            if (row.attachmentVisible) {
                row.rfqFiles = [];
                row.fileSearch = "";
                row.attachmentLoading = true;
                this.$store
                    .dispatch("filemanager/GetFiles", {
                        id: row.id,
                        type: this.uploadOptions.type,
                    })
                    .then((res) => {
                        row.attachmentLoading = false;
                        row.rfqFiles = res.data;
                    })
                    .catch(() => {
                        row.attachmentLoading = false;
                        this.showToast(
                            "Something went wrong! - getting documents",
                            "error"
                        );
                    });
            }
        },
        searchDocu(row) {
            let data = row.rfqFiles;
            if (row.fileSearch.trim() != "" && row.fileSearch) {
                data = data.filter((item) => {
                    return item.description
                        .toUpperCase()
                        .includes(row.fileSearch.toUpperCase());
                });
            }
            return data;
        },
        openDocument(x) {
            this.readFile(x.id)
        },
        addAttachment(row) {
            this.$emit('showSupplierUploads', row.id);
        },
        printAbstract(id) {
            this.$emit('printAbstract', id);
        },
    }
}
</script>
<template>
    <div>
        <b-tabs
            pills
            vertical
            nav-class="p-0"
            nav-wrapper-class="col-sm-2"
            content-class="pt-0 px-2 text-muted"
        >
            <b-tab @click="getPendingData">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Pending</span>
                </template>
                <div class="card">
                    <div class="card-body bg-primary bg-soft">
                        <div
                            class="
                                d-flex
                                justify-content-between
                                align-items-center
                                mb-3
                            "
                        >
                            <div>
                                <h4 class="card-title mb-0">
                                    Pending RFQ
                                </h4>
                                <p class="card-title-desc mb-0">
                                    List of pending RFQ
                                </p>
                            </div>
                            <div v-if="pendingData.length > 0">
                                <input
                                    autocomplete="off"
                                    id="name"
                                    type="text"
                                    v-model="filterPending"
                                    placeholder="Search RFQ..."
                                    class="form-control"
                                />
                            </div>
                        </div>
                        <div
                            v-if="pendingLoading"
                            class="text-center"
                        >
                            <div
                                class="
                                    d-flex
                                    justify-content-center
                                    align-items-center
                                "
                            >
                                <div
                                    class="
                                        preloader-component
                                        me-2
                                    "
                                >
                                    <div class="status">
                                        <div
                                            class="
                                                spinner-chase
                                                w-20px
                                                h-20px
                                            "
                                        >
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                                <strong
                                    >Loading...</strong
                                >
                            </div>
                        </div>
                        <div
                            v-if="!pendingLoading && pendingData.length == 0"
                            class="text-center"
                        >
                            <h5>No data available</h5>
                        </div>
                        <div
                            v-if="
                                !pendingLoading && filterPending &&
                                filteredPending.length == 0
                            "
                            class="text-center"
                        >
                            <h5>Search not found</h5>
                        </div>
                        <div v-if="!pendingLoading &&  pendingData.length > 0">
                            <div
                                role="tablist"
                                v-for="x in filteredPending"
                                :key="x.id"
                            >
                                <b-card
                                    no-body
                                    class="mb-1 shadow-none"
                                >
                                    <b-card-header
                                        header-tag="header"
                                        role="tab"
                                        header-class="cursor-pointer"
                                        @click="x.visible = !x.visible"
                                    >
                                        <div
                                            class="
                                                d-flex
                                                justify-content-between
                                                align-items-center
                                            "
                                        >
                                            <div>
                                                <h6 class="m-0">
                                                    <a
                                                        class="text-dark"
                                                        href="javascript: void(0);"
                                                        >[{{
                                                            x.rfqNumber
                                                        }}]:&nbsp;{{
                                                            x.description
                                                        }}</a
                                                    >
                                                </h6>
                                                <small class="text-warning">Sign as {{x.position}}</small>
                                                <span class="mx-1">|</span>
                                                <small class="text-green">
                                                    Posted on {{ formatDate(new Date(x.dateTimePosted)) }} ({{diffDate(x.dateTimePosted, getDate(new Date()))}}) 
                                                </small>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <div>
                                                    <span class="d-flex align-items-center">
                                                        <small v-if="!x.visible">Click here to expand</small>
                                                        <i 
                                                            class="bx bx-chevron-right rotate font-size-18 ms-3"
                                                            :class="{'rotate-90': x.visible}"
                                                        ></i
                                                    ></span>
                                                </div>
                                            </div>
                                        </div>
                                    </b-card-header>
                                    <b-collapse
                                        :visible="x.visible"
                                        :accordion="`posted-accordion-${x.id}`"
                                        role="tabpanel"
                                    >
                                        <b-card-body class="border">
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    justify-content-between
                                                    cursor-pointer
                                                "
                                            >
                                                <h5 class="mb-0">
                                                    Details
                                                </h5>
                                                <h5 class="mb-0">
                                                    <i
                                                        class="
                                                            bx
                                                            bx-chevron-right
                                                            rotate
                                                        "
                                                        :class="{
                                                            'rotate-90':
                                                                x.detailShow,
                                                        }"
                                                    ></i>
                                                </h5>
                                            </div>
                                            <b-collapse
                                                :visible="x.detailShow"
                                                :accordion="`rfq-details-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <hr />
                                                <div class="row">
                                                    <div
                                                        class="col-md-6"
                                                    >
                                                    <ul>
                                                        <li>
                                                            <div>
                                                            <label
                                                                class="
                                                                    me-1
                                                                "
                                                                ><i
                                                                    class="
                                                                        bx
                                                                        bx-receipt
                                                                        me-1
                                                                    "
                                                                ></i
                                                                >Tracking
                                                                Number:</label
                                                            >
                                                            <u>{{
                                                                x.tracking
                                                            }}</u>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div>
                                                                <label class="me-1">
                                                                    <i class="bx bx-calendar-event me-1"></i>Bids/RFQ Date:
                                                                </label>
                                                                <u>{{ formatDate(new Date(x.dateTimePosted)) }}</u>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                    </div>
                                                    <div
                                                        class="col-md-6"
                                                    >
                                                        <ul>
                                                            <li>
                                                                Note: {{x.note}}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </b-collapse>
                                            <hr />
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    justify-content-between
                                                    cursor-pointer
                                                "
                                                @click="getRfqItems(x)"
                                            >
                                                <h5 class="mb-0">
                                                    RFQ Items
                                                </h5>
                                                <h5 class="mb-0">
                                                    <i
                                                        class="bx bx-chevron-right rotate"
                                                        :class="{'rotate-90': x.itemVisible}"
                                                    ></i>
                                                </h5>
                                            </div>
                                            <b-collapse
                                                :visible="x.itemVisible"
                                                :accordion="`rfq-item-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <hr />
                                                <table class="table table-bordered">
                                                    <thead>
                                                        <tr class="custom-border-2">
                                                            <th>Item Name
                                                                <div><small>Item Description</small></div>
                                                            </th>
                                                            <th style="width: 120px;">Unit</th>
                                                            <th style="width: 70px;">Qty</th>
                                                            <th style="width: 150px;">Unit Cost</th>
                                                            <th style="width: 150px;">Total</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-if="x.rfqItemLoading">
                                                            <td colspan="5">
                                                                <div class="d-flex justify-content-center align-items-center">
                                                                    <div class="preloader-component me-2">
                                                                        <div class="status">
                                                                            <div class="spinner-chase w-20px h-20px">
                                                                                <div class="chase-dot"></div>
                                                                                <div class="chase-dot"></div>
                                                                                <div class="chase-dot"></div>
                                                                                <div class="chase-dot"></div>
                                                                                <div class="chase-dot"></div>
                                                                                <div class="chase-dot"></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <strong>Loading...</strong>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <template v-if="!x.rfqItemLoading && x.rfqItems.length > 0">
                                                            <tr
                                                                v-for="z in x.rfqItems"
                                                                :key="`poffer-${z.id}`"
                                                            >
                                                                <td>{{ z.itemName}}
                                                                    <div><small>{{ z.description}}</small></div>
                                                                </td>
                                                                <td>{{ x.rfqItemLoaded && z.unit.shortName }}</td>
                                                                <td>{{ x.rfqItemLoaded && z.quantity}}</td>
                                                                <td>{{ x.rfqItemLoaded && formatCurrency(z.unitCost)}}</td>
                                                                <td>{{ x.rfqItemLoaded && formatCurrency(z.total)}}</td>
                                                            </tr>
                                                        </template>
                                                        <tr v-if="!x.rfqItemLoading && x .rfqItems.length == 0">
                                                            <td colspan="5" class="text-center">
                                                                <i>No offer yet</i>
                                                            </td>
                                                        </tr>
                                                        <tr class="border border-dashed">
                                                            <td colspan="4" class="text-right py-2 px-2">Total RFQ Amount:</td>
                                                            <td colspan="2" class="py-2">{{ formatCurrency(getTotalPerPR(x.rfqItems))}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </b-collapse>
                                            <hr />
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    justify-content-between
                                                    cursor-pointer
                                                "
                                                @click="
                                                    getRfqSupplier(x)
                                                "
                                            >
                                                <h5 class="mb-0">
                                                    Suppliers &amp; Offers
                                                </h5>
                                                <h5 class="mb-0">
                                                    <i
                                                        class="
                                                            bx
                                                            bx-chevron-right
                                                            rotate
                                                        "
                                                        :class="{
                                                            'rotate-90':
                                                                x.supplierShow,
                                                        }"
                                                    ></i>
                                                </h5>
                                            </div>
                                            <b-collapse
                                                :visible="
                                                    x.supplierShow
                                                "
                                                :accordion="`supplier-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <hr />
                                                <template v-if="x.supplierLoading">
                                                    <div class="d-flex justify-content-center align-items-center">
                                                        <div class="preloader-component me-2">
                                                            <div class="status">
                                                                <div class="spinner-chase w-20px h-20px">
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <strong>Loading...</strong>
                                                    </div>
                                                </template>
                                                <template v-if="!x.supplierLoading && !x.rfqSuppliers.length">
                                                    <p class="text-center">No data found.</p>
                                                </template>
                                                <template v-if="!x.supplierLoading && x.rfqSuppliers.length">
                                                    <b-card
                                                        no-body
                                                        class="mb-1 shadow-none"
                                                        v-for="(y, index) in x.rfqSuppliers"
                                                        :key="y.id"
                                                    >
                                                        <b-card-header
                                                            header-tag="header"
                                                            role="tab"
                                                            class="border"
                                                            :class="{'border-success': y.isWinner}"
                                                        >
                                                            <div
                                                                class="
                                                                    d-flex
                                                                    justify-content-between
                                                                    align-items-center
                                                                "
                                                            >
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                        align-items-center
                                                                    "
                                                                >
                                                                    <div
                                                                        style="
                                                                            min-width: 30px;
                                                                        "
                                                                        class="
                                                                            bg-success
                                                                            bg-gradient
                                                                            text-center
                                                                            me-2
                                                                            py-1
                                                                            position-relative
                                                                        "
                                                                    >
                                                                        <h3
                                                                            class="
                                                                                mb-0
                                                                                position-relative
                                                                            "
                                                                        >
                                                                            {{
                                                                                index +
                                                                                1
                                                                            }}
                                                                            <i
                                                                                class="
                                                                                    bx
                                                                                    bx-crown
                                                                                    position-absolute
                                                                                    winner-crown
                                                                                    font-size-14
                                                                                "
                                                                                v-if="
                                                                                    y.isWinner
                                                                                "
                                                                            ></i>
                                                                        </h3>
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            text-muted
                                                                        "
                                                                    >
                                                                        <h5
                                                                            class="
                                                                                mb-0
                                                                            "
                                                                        >
                                                                            {{
                                                                                y
                                                                                    .supplier
                                                                                    .name
                                                                            }}
                                                                        </h5>
                                                                        <div
                                                                            style="
                                                                                line-height: 0.8;
                                                                            "
                                                                        >
                                                                            <small
                                                                                >{{
                                                                                    y
                                                                                        .supplier
                                                                                        .address
                                                                                }}</small
                                                                            >
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                        align-items-center
                                                                    "
                                                                >
                                                                    <span
                                                                        v-if="
                                                                            y.isWinner
                                                                        "
                                                                        class="
                                                                            me-5
                                                                        "
                                                                        >Winner</span
                                                                    >
                                                                    <a
                                                                        href="javascript: void(0);"
                                                                        class="
                                                                            text-success
                                                                            d-flex
                                                                            align-items-center
                                                                        "
                                                                        @click="
                                                                            y.visible =
                                                                                !y.visible
                                                                        "
                                                                    >
                                                                        {{
                                                                            y.visible
                                                                                ? "Hide"
                                                                                : "Show"
                                                                        }}
                                                                        Offer
                                                                        <i
                                                                            class="
                                                                                bx
                                                                                bx-chevron-right
                                                                                rotate
                                                                                font-size-14
                                                                            "
                                                                            :class="{
                                                                                'rotate-90':
                                                                                    y.visible,
                                                                            }"
                                                                        ></i>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </b-card-header>
                                                        <b-collapse
                                                            :visible="
                                                                y.visible
                                                            "
                                                            :accordion="`posted-supplier-${y.id}`"
                                                            role="tabpanel"
                                                        >
                                                            <table
                                                                class="
                                                                    table
                                                                    table-bordered
                                                                "
                                                            >
                                                                <thead>
                                                                    <tr>
                                                                        <th>
                                                                            Item
                                                                            Name
                                                                            <div>
                                                                                <small
                                                                                    >Item
                                                                                    Description</small
                                                                                >
                                                                            </div>
                                                                        </th>
                                                                        <th
                                                                            style="
                                                                                width: 120px;
                                                                            "
                                                                        >
                                                                            Unit
                                                                        </th>
                                                                        <th
                                                                            style="
                                                                                width: 70px;
                                                                            "
                                                                        >
                                                                            Qty
                                                                        </th>
                                                                        <th
                                                                            style="
                                                                                width: 150px;
                                                                            "
                                                                        >
                                                                            Unit
                                                                            Cost
                                                                        </th>
                                                                        <th
                                                                            style="
                                                                                width: 150px;
                                                                            "
                                                                        >
                                                                            Total
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr
                                                                        v-for="z in y.rfqSupplierOffers"
                                                                        :key="`poffer-${z.id}`"
                                                                        :class="{
                                                                            'custom-border-2 border-success':
                                                                                z.isWinner,
                                                                        }"
                                                                    >
                                                                        <td class="position-relative">
                                                                            <RawData 
                                                                                :data="z" 
                                                                                v-if="$store.state.decrypt.isAdmin()" 
                                                                                placement="left"
                                                                                :key="`bacmember-${x.id}`"
                                                                            />
                                                                            {{z.itemName}}
                                                                            <div><small>{{z.description}}</small></div>
                                                                            <div><p class="mb-0" v-if="z.deliveryPeriod">{{z.deliveryPeriod}} calendar day(s)</p></div>
                                                                            <div>
                                                                                <a
                                                                                    href="javascript:void(0);"
                                                                                    :id="`moreSpec${z.id}`"
                                                                                    ><i
                                                                                        class="
                                                                                            mdi mdi-triangle
                                                                                            rotate rotate-90
                                                                                            me-1
                                                                                        "
                                                                                    ></i
                                                                                    >More Specifications</a
                                                                                >
                                                                                <b-popover
                                                                                    :target="`moreSpec${z.id}`"
                                                                                    triggers="click"
                                                                                    placement="right"
                                                                                    :show.sync="z.showMoreSpec"
                                                                                    custom-class="popover-supplier"
                                                                                >
                                                                                    <template v-slot:title>
                                                                                        <div
                                                                                            class="
                                                                                                d-flex
                                                                                                align-items-center
                                                                                                justify-content-between
                                                                                            "
                                                                                        >
                                                                                            <small
                                                                                                >More Specifications</small
                                                                                            >
                                                                                            <span
                                                                                                class="
                                                                                                    bx bx-x
                                                                                                    font-size-14
                                                                                                    cursor-pointer
                                                                                                "
                                                                                                @click="
                                                                                                    z.showMoreSpec = false
                                                                                                "
                                                                                            ></span>
                                                                                        </div>
                                                                                    </template>
                                                                                    <div class="row mb-2">
                                                                                        <div class="col-md-6">
                                                                                            <label for="" class="mb-0"
                                                                                                >Brand</label
                                                                                            >
                                                                                            <div
                                                                                                type="text"
                                                                                                placeholder="Enter Brand"
                                                                                                class="
                                                                                                    form-control
                                                                                                    form-control-sm
                                                                                                "
                                                                                            >
                                                                                                {{z.brand}}
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="col-md-6">
                                                                                            <label for="" class="mb-0"
                                                                                                >Model</label
                                                                                            >
                                                                                            <div
                                                                                                class="
                                                                                                    form-control
                                                                                                    form-control-sm
                                                                                                "
                                                                                                
                                                                                            >
                                                                                                {{z.model}}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="row mb-2">
                                                                                        <div class="col-md-6">
                                                                                            <label for="" class="mb-0"
                                                                                                >Color</label
                                                                                            >
                                                                                            <div
                                                                                                class="
                                                                                                    form-control
                                                                                                    form-control-sm
                                                                                                "
                                                                                            >
                                                                                                {{z.color}}
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="col-md-6">
                                                                                            <label for="" class="mb-0"
                                                                                                >Condition</label
                                                                                            >
                                                                                            <div
                                                                                                class="
                                                                                                    form-control
                                                                                                    form-control-sm
                                                                                                "
                                                                                            >
                                                                                                {{z.condition}}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="row mb-2">
                                                                                        <div class="col-md-6">
                                                                                            <label for="" class="mb-0"
                                                                                                >Material Used</label
                                                                                            >
                                                                                            <div
                                                                                                class="
                                                                                                    form-control
                                                                                                    form-control-sm
                                                                                                "
                                                                                            >
                                                                                                {{z.materialUsed}}
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="col-md-6">
                                                                                            <label for="" class="mb-0"
                                                                                                >Package Description</label
                                                                                            >
                                                                                            <div
                                                                                                class="
                                                                                                    form-control
                                                                                                    form-control-sm
                                                                                                "
                                                                                            >
                                                                                                {{z.packageDescription}}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="mb-2">
                                                                                        <label for="" class="mb-0"
                                                                                            >Dimension Description</label
                                                                                        >
                                                                                        <div
                                                                                            class="
                                                                                                form-control form-control-sm
                                                                                            "
                                                                                        >
                                                                                            {{z.dimensionDescription}}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="mb-2">
                                                                                        <label for="" class="mb-0"
                                                                                            >Other Specifications</label
                                                                                        >
                                                                                        <div
                                                                                            class="
                                                                                                form-control form-control-sm
                                                                                            "
                                                                                        >
                                                                                            {{z.specification}}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="mb-2">
                                                                                        <label for="" class="mb-0">Notes</label>
                                                                                        <div class="form-control form-control-sm text-warning">
                                                                                            {{z.note}}
                                                                                        </div>
                                                                                    </div>
                                                                                </b-popover>
                                                                            </div>
                                                                        </td>
                                                                        <template v-if="z.noOffer">
                                                                            <td colspan="4" class="text-center align-middle text-warning">
                                                                                Supplier no offer
                                                                            </td>
                                                                        </template>
                                                                        <template v-else>
                                                                            <td>{{ z.unit.unitName }}</td>
                                                                            <td>{{ z.quantity }}</td>
                                                                            <td>{{ formatCurrency(z.unitCost) }}</td>
                                                                            <td>{{ formatCurrency(parseFloat(z.unitCost) * parseFloat(z.quantity)) }}
                                                                                <div class="mt-2"
                                                                                    v-if="z.isWinner"
                                                                                >
                                                                                    <small class="badge text-warning"><i class="bx bx-crown me-1"></i>Winner</small>
                                                                                </div>
                                                                            </td>
                                                                        </template>
                                                                        <!-- <td>{{ z.unit.unitName }}</td>
                                                                        <td>{{ z.quantity }}</td>
                                                                        <td>{{ formatCurrency(z.unitCost) }}</td>
                                                                        <td>
                                                                            {{ formatCurrency(parseFloat(z.unitCost) * parseFloat(z.quantity))}}
                                                                            <div class="mt-2" v-if="z.isWinner">
                                                                                <small class="badge text-warning">
                                                                                    <i class="bx bx-crown me-1"></i>Winner
                                                                                </small>
                                                                            </div>
                                                                        </td> -->
                                                                    </tr>
                                                                    <tr v-if="y.rfqSupplierOffers.length == 0">
                                                                        <td
                                                                            colspan="5"
                                                                            class="text-center"
                                                                        >
                                                                            <i>No offer yet</i>
                                                                        </td>
                                                                    </tr>
                                                                    <tr
                                                                        class="
                                                                            border
                                                                            border-dashed
                                                                        "
                                                                    >
                                                                        <td
                                                                            class="
                                                                                py-2
                                                                            "
                                                                            colspan="3"
                                                                        >
                                                                            <div>
                                                                                <button
                                                                                    type="button"
                                                                                    class="btn btn-link"
                                                                                    @click="addAttachment(y)"
                                                                                >
                                                                                    <i class="mdi mdi-paperclip"></i> Attachments
                                                                                </button>
                                                                            </div>
                                                                        </td>
                                                                        <td
                                                                            class="
                                                                                text-right
                                                                                py-2
                                                                                px-2
                                                                            "
                                                                        >
                                                                            Total
                                                                            Offer
                                                                            Amount:
                                                                        </td>
                                                                        <td
                                                                            colspan="2"
                                                                            class="py-2"
                                                                        >
                                                                            {{ formatCurrency(getTotalOffer(y.rfqSupplierOffers)) }}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </b-collapse>
                                                    </b-card>
                                                </template>
                                            </b-collapse>
                                            <hr />
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    justify-content-between
                                                    cursor-pointer
                                                "
                                                @click="
                                                    getAttachments(x)
                                                "
                                            >
                                                <h5 class="mb-0 text-warning">
                                                    <i
                                                        class="
                                                            bx
                                                            bx-paperclip
                                                            rotate
                                                            rotate-90
                                                        "
                                                    ></i>
                                                    Attachments
                                                </h5>
                                                <h5 class="mb-0">
                                                    <i
                                                        class="
                                                            bx
                                                            bx-chevron-right
                                                            rotate
                                                        "
                                                        :class="{
                                                            'rotate-90':
                                                                x.attachmentVisible,
                                                        }"
                                                    ></i>
                                                </h5>
                                            </div>
                                            <b-collapse
                                                :visible="
                                                    x.attachmentVisible
                                                "
                                                :accordion="`posted-attachment-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <hr />
                                                <div
                                                    class="
                                                        d-flex
                                                        align-items-center
                                                        justify-content-between
                                                        mb-3
                                                    "
                                                >
                                                    <div class="d-flex">
                                                        <p
                                                            class="mb-0"
                                                            v-if="!x.attachmentLoading &&
                                                                x
                                                                    .rfqFiles
                                                                    .length ==
                                                                0
                                                            "
                                                        >
                                                            <i
                                                                >No
                                                                documents
                                                                found</i
                                                            >
                                                        </p>
                                                        <p
                                                            class="mb-0"
                                                            v-if="
                                                                x.attachmentLoading
                                                            "
                                                        >
                                                            <i class="font-size-15">Loading...</i
                                                            >
                                                        </p>
                                                        <input
                                                            v-if="!x.attachmentLoading &&
                                                                x
                                                                    .rfqFiles
                                                                    .length >
                                                                0
                                                            "
                                                            type="search"
                                                            class="
                                                                form-control
                                                            "
                                                            v-model="
                                                                x.fileSearch
                                                            "
                                                            @input="
                                                                searchDocu(
                                                                    x
                                                                )
                                                            "
                                                            placeholder="Search Documents..."
                                                        />
                                                    </div>
                                                </div>
                                                <div class="mt-2">
                                                    <b-row>
                                                        <b-col
                                                            sm="3"
                                                            v-for="(
                                                                y, index
                                                            ) in searchDocu(
                                                                x
                                                            )"
                                                            :key="y.id"
                                                            class="mb-2"
                                                        >
                                                            <div
                                                                class="
                                                                    position-relative
                                                                    cursor-pointer
                                                                "
                                                                :style="`z-index: ${
                                                                    searchDocu(
                                                                        x
                                                                    )
                                                                        .length -
                                                                    index
                                                                }`"
                                                            >
                                                                <div
                                                                    class="
                                                                        border
                                                                        p-3
                                                                    "
                                                                >
                                                                    <div>
                                                                        <div
                                                                            class="
                                                                                float-end
                                                                                ms-2
                                                                            "
                                                                        >
                                                                            <b-dropdown
                                                                                id="dropdown-dropleft"
                                                                                right
                                                                                variant="link"
                                                                                toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                                                                menu-class="dropdown-menu-end"
                                                                                no-caret
                                                                            >
                                                                                <template
                                                                                    #button-content
                                                                                >
                                                                                    <i
                                                                                        class="
                                                                                            mdi
                                                                                            mdi-dots-horizontal
                                                                                        "
                                                                                    ></i>
                                                                                </template>
                                                                                <b-dropdown-item
                                                                                    @click="
                                                                                        openDocument(
                                                                                            y
                                                                                        )
                                                                                    "
                                                                                    ><i
                                                                                        class="
                                                                                            bx
                                                                                            bx-link-external
                                                                                            me-1
                                                                                        "
                                                                                    ></i
                                                                                    >Open</b-dropdown-item
                                                                                >
                                                                            </b-dropdown>
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                avatar-xs
                                                                                me-3
                                                                                mb-2
                                                                            "
                                                                            @click="
                                                                                openDocument(
                                                                                    y
                                                                                )
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="
                                                                                    avatar-title
                                                                                    bg-transparent
                                                                                    rounded
                                                                                "
                                                                            >
                                                                                <i
                                                                                    v-if="
                                                                                        y.fileType.includes(
                                                                                            'image'
                                                                                        )
                                                                                    "
                                                                                    class="
                                                                                        mdi
                                                                                        mdi-image
                                                                                        font-size-24
                                                                                        text-purple
                                                                                    "
                                                                                ></i>
                                                                                <i
                                                                                    v-if="
                                                                                        y.fileType.includes(
                                                                                            'application'
                                                                                        )
                                                                                    "
                                                                                    class="
                                                                                        mdi
                                                                                        mdi-file-pdf-outline
                                                                                        font-size-24
                                                                                        text-danger
                                                                                    "
                                                                                ></i>
                                                                            </div>
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                d-flex
                                                                            "
                                                                            @click="
                                                                                openDocument(
                                                                                    y
                                                                                )
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="
                                                                                    overflow-hidden
                                                                                    me-auto
                                                                                "
                                                                            >
                                                                                <h5
                                                                                    class="
                                                                                        font-size-14
                                                                                        text-truncate
                                                                                        mb-1
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        y.description
                                                                                    }}
                                                                                </h5>
                                                                                <p
                                                                                    class="
                                                                                        text-muted
                                                                                        mb-0
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        formatDateWithTime(
                                                                                            new Date(
                                                                                                y.dateTimeUploaded
                                                                                            )
                                                                                        )
                                                                                    }}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row
                                                        v-if="
                                                            searchDocu(
                                                                x
                                                            ).length ==
                                                                0 &&
                                                            x.fileSearch
                                                        "
                                                    >
                                                        <b-col
                                                            >Search Not
                                                            Found</b-col
                                                        >
                                                    </b-row>
                                                </div>
                                            </b-collapse>
                                            <hr />
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    justify-content-between
                                                    cursor-pointer
                                                "
                                                @click="getBACMembers(x)"
                                            >
                                                <div>
                                                    <h5 class="mb-0 text-primary d-flex align-items-center">
                                                        <i
                                                            class="
                                                                bx bx-user-check font-size-18 me-1
                                                            "
                                                        ></i>
                                                        BAC Resolution Members
                                                    </h5>
                                                </div>
                                                <h5 class="mb-0">
                                                    <i
                                                        class="
                                                            bx
                                                            bx-chevron-right
                                                            rotate
                                                        "
                                                        :class="{
                                                            'rotate-90':
                                                                x.memberVisible,
                                                        }"
                                                    ></i>
                                                </h5>
                                            </div>
                                            <b-collapse
                                                :visible="x.memberVisible"
                                                :accordion="`approved-member-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <hr />
                                                <template v-if="x.memberLoading">
                                                    <div class="d-flex justify-content-center align-items-center">
                                                        <div class="preloader-component me-2">
                                                            <div class="status">
                                                                <div class="spinner-chase w-20px h-20px">
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <strong>Loading...</strong>
                                                    </div>
                                                </template>
                                                <template v-if="!x.memberLoading && x.rfqBacSettings.length == 0">
                                                    <h4 class="text-center">No data found...</h4>
                                                </template>
                                                <template v-if="!x.memberLoading && x.rfqBacSettings.length > 0">
                                                    <template v-for="y in x.rfqBacSettings">
                                                        <div
                                                            class="
                                                                ms-3
                                                                mb-1
                                                                p-3
                                                                broken-border
                                                            "
                                                            :class="{
                                                                'broken-border-success': y.status.toUpperCase() !== 'PENDING'
                                                            }"
                                                            :key="y.id"
                                                        >
                                                            <div
                                                                class="
                                                                    d-flex
                                                                    align-items-center
                                                                    justify-content-between
                                                                "
                                                            >
                                                                <div>
                                                                    <span class="font-weight-bold text-white">{{y.employeeName ? y.employeeName : ''}}</span>
                                                                    <div>
                                                                        <small
                                                                            >{{y.bacName}} {{y.position}}</small
                                                                        >
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="text-center font-weight-bold font-size-18"
                                                                    :class="{
                                                                        'text-warning': y.status.toUpperCase() === 'PENDING',
                                                                        'text-green': y.status.toUpperCase() !== 'PENDING'
                                                                    }"
                                                                >
                                                                        {{y.status.toUpperCase() === 'APPROVED' ? 'DIGITALLY SIGNED': 'PENDING'}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </template>
                                            </b-collapse>
                                            <hr />
                                            <div class="d-flex">
                                                <button
                                                    type="button"
                                                    class="
                                                        btn btn-purple
                                                        me-2
                                                    "
                                                    @click="
                                                        printAbstract(
                                                            x.id
                                                        )
                                                    "
                                                >
                                                    <i
                                                        class="
                                                            bx
                                                            bxs-printer
                                                            me-1
                                                        "
                                                    ></i
                                                    >Print Abstract
                                                </button>
                                                <button
                                                    type="button"
                                                    class="
                                                        btn btn-success
                                                        me-2
                                                    "
                                                    @click="
                                                        approveAOQ(x)
                                                    "
                                                >
                                                    <i
                                                        class="
                                                            bx
                                                            bx-check
                                                            me-1
                                                        "
                                                    ></i
                                                    >Sign Digitally
                                                </button>
                                            </div>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>
                            </div>
                        </div>
                    </div>
                </div>
            </b-tab>
            <b-tab @click="getApprovedData">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Approved</span>
                </template>
                <div class="card">
                    <div class="card-body bg-success bg-soft">
                        <div
                            class="
                                d-flex
                                justify-content-between
                                align-items-center
                                mb-3
                            "
                        >
                            <div>
                                <h4 class="card-title mb-0">
                                    Approved RFQ
                                </h4>
                                <p class="card-title-desc mb-0">
                                    List of approved RFQ
                                </p>
                            </div>
                            <div v-if="approvedData.length > 0">
                                <input
                                    autocomplete="off"
                                    id="name"
                                    type="text"
                                    v-model="filterPending"
                                    placeholder="Search RFQ..."
                                    class="form-control"
                                />
                            </div>
                        </div>
                        <div
                            v-if="approvedLoading"
                            class="text-center"
                        >
                            <div
                                class="
                                    d-flex
                                    justify-content-center
                                    align-items-center
                                "
                            >
                                <div
                                    class="
                                        preloader-component
                                        me-2
                                    "
                                >
                                    <div class="status">
                                        <div
                                            class="
                                                spinner-chase
                                                w-20px
                                                h-20px
                                            "
                                        >
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                                <strong
                                    >Loading...</strong
                                >
                            </div>
                        </div>
                        <div
                            v-if="!approvedLoading && approvedData.length == 0"
                            class="text-center"
                        >
                            <h5>No data available</h5>
                        </div>
                        <div
                            v-if="
                                !approvedLoading && filterApproved &&
                                filteredApproved.length == 0
                            "
                            class="text-center"
                        >
                            <h5>Search not found</h5>
                        </div>
                        <div v-if="!pendingLoading &&  approvedData.length > 0">
                            <div
                                role="tablist"
                                v-for="x in filteredApproved"
                                :key="x.id"
                            >
                                <b-card
                                    no-body
                                    class="mb-1 shadow-none"
                                >
                                    <b-card-header
                                        header-tag="header"
                                        role="tab"
                                        header-class="cursor-pointer"
                                        @click="x.visible = !x.visible"
                                    >
                                        <div
                                            class="
                                                d-flex
                                                justify-content-between
                                                align-items-center
                                            "
                                        >
                                            <div>
                                                <h6 class="m-0">
                                                    <a
                                                        class="text-dark"
                                                        href="javascript: void(0);"
                                                        >[{{
                                                            x.rfqNumber
                                                        }}]:&nbsp;{{
                                                            x.description
                                                        }}</a
                                                    >
                                                </h6>
                                                <small class="text-warning">Sign as {{x.position}}</small>
                                            </div>
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                "
                                            >
                                                <div>
                                                    <span
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                        "
                                                        ><small
                                                            v-if="
                                                                !x.visible
                                                            "
                                                            >Click here
                                                            to
                                                            expand</small
                                                        ><i
                                                            class="
                                                                bx
                                                                bx-chevron-right
                                                                rotate
                                                                font-size-18
                                                                ms-3
                                                            "
                                                            :class="{
                                                                'rotate-90':
                                                                    x.visible,
                                                            }"
                                                        ></i
                                                    ></span>
                                                </div>
                                            </div>
                                        </div>
                                    </b-card-header>
                                    <b-collapse
                                        :visible="x.visible"
                                        :accordion="`posted-accordion-${x.id}`"
                                        role="tabpanel"
                                    >
                                        <b-card-body class="border">
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    justify-content-between
                                                    cursor-pointer
                                                "
                                            >
                                                <h5 class="mb-0">
                                                    Details
                                                </h5>
                                                <h5 class="mb-0">
                                                    <i
                                                        class="
                                                            bx
                                                            bx-chevron-right
                                                            rotate
                                                        "
                                                        :class="{
                                                            'rotate-90':
                                                                x.detailShow,
                                                        }"
                                                    ></i>
                                                </h5>
                                            </div>
                                            <b-collapse
                                                :visible="x.detailShow"
                                                :accordion="`rfq-details-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <hr />
                                                <div class="row">
                                                    <div
                                                        class="col-md-6"
                                                    >
                                                    <ul>
                                                        <li>
                                                            <div>
                                                            <label
                                                                class="
                                                                    me-1
                                                                "
                                                                ><i
                                                                    class="
                                                                        bx
                                                                        bx-receipt
                                                                        me-1
                                                                    "
                                                                ></i
                                                                >Tracking
                                                                Number:</label
                                                            >
                                                            <u>{{
                                                                x.tracking
                                                            }}</u>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div>
                                                                <label
                                                                    class="
                                                                        me-1
                                                                    "
                                                                    ><i
                                                                        class="
                                                                            bx
                                                                            bx-calendar-event
                                                                            me-1
                                                                        "
                                                                    ></i
                                                                    >Bids/RFQ
                                                                    Date:</label
                                                                >
                                                                <u>{{formatDate(new Date(x.dateTimePosted))}}</u>
                                                            </div>
                                                        </li>
                                                        <!-- <li>
                                                            <div>
                                                                <label
                                                                    class="
                                                                        me-1
                                                                    "
                                                                    ><i
                                                                        class="
                                                                            bx
                                                                            bx-calendar-event
                                                                            me-1
                                                                        "
                                                                    ></i
                                                                    >Bids/RFQ
                                                                    Deadline:</label
                                                                >
                                                                <u>{{
                                                                    formatDate(
                                                                        new Date(
                                                                            x.deadline
                                                                        )
                                                                    )
                                                                }}</u>
                                                            </div>
                                                        </li> -->
                                                    </ul>
                                                    </div>
                                                    <div
                                                        class="col-md-6"
                                                    >
                                                        <ul>
                                                            <li>
                                                                Note: {{x.note}}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </b-collapse>
                                            <hr />
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    justify-content-between
                                                    cursor-pointer
                                                "
                                                @click="
                                                    getRfqItems(x)
                                                "
                                            >
                                                <h5 class="mb-0">
                                                    RFQ Items
                                                </h5>
                                                <h5 class="mb-0">
                                                    <i
                                                        class="
                                                            bx
                                                            bx-chevron-right
                                                            rotate
                                                        "
                                                        :class="{
                                                            'rotate-90':
                                                                x.itemVisible,
                                                        }"
                                                    ></i>
                                                </h5>
                                            </div>
                                            <b-collapse
                                                :visible="x.itemVisible"
                                                :accordion="`rfq-item-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <hr />
                                                <table
                                                    class="
                                                        table
                                                        table-bordered
                                                    "
                                                >
                                                    <thead>
                                                        <tr
                                                            class="
                                                                custom-border-2
                                                            "
                                                        >
                                                            <th>
                                                                Item
                                                                Name
                                                                <div>
                                                                    <small
                                                                        >Item
                                                                        Description</small
                                                                    >
                                                                </div>
                                                            </th>
                                                            <th
                                                                style="
                                                                    width: 120px;
                                                                "
                                                            >
                                                                Unit
                                                            </th>
                                                            <th
                                                                style="
                                                                    width: 70px;
                                                                "
                                                            >
                                                                Qty
                                                            </th>
                                                            <th
                                                                style="
                                                                    width: 150px;
                                                                "
                                                            >
                                                                Unit
                                                                Cost
                                                            </th>
                                                            <th
                                                                style="
                                                                    width: 150px;
                                                                "
                                                            >
                                                                Total
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-if="x.rfqItemLoading">
                                                            <td colspan="5">
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                        justify-content-center
                                                                        align-items-center
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            preloader-component
                                                                            me-2
                                                                        "
                                                                    >
                                                                        <div class="status">
                                                                            <div
                                                                                class="
                                                                                    spinner-chase
                                                                                    w-20px
                                                                                    h-20px
                                                                                "
                                                                            >
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <strong
                                                                        >Loading...</strong
                                                                    >
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <template v-if="!x.rfqItemLoading && x.rfqItems.length > 0">
                                                            <tr
                                                                v-for="z in x.rfqItems"
                                                                :key="`poffer-${z.id}`"
                                                            >
                                                                <td>
                                                                    {{
                                                                        z
                                                                            .prItem
                                                                            .apiResource
                                                                            .itemName
                                                                    }}
                                                                    <div>
                                                                        <small>
                                                                            {{
                                                                                z
                                                                                    .prItem
                                                                                    .apiResource
                                                                                    .description
                                                                            }}
                                                                        </small>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                {{
                                                                        x.rfqItemLoaded &&
                                                                        z
                                                                            .prItem
                                                                            .apiResource
                                                                            .unit
                                                                            .unitName
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        x.rfqItemLoaded &&
                                                                        z
                                                                            .prItem
                                                                            .totalQuantity
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        x.rfqItemLoaded && formatCurrency(
                                                                            z
                                                                                .prItem
                                                                                .unitCost
                                                                        )
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        x.rfqItemLoaded &&formatCurrency(
                                                                            z
                                                                                .prItem
                                                                                .total
                                                                        )
                                                                    }}
                                                                </td>
                                                            </tr>
                                                        </template>
                                                        <tr
                                                            v-if="
                                                                !x.rfqItemLoading &&
                                                                x
                                                                    .rfqItems
                                                                    .length ==
                                                                0
                                                            "
                                                        >
                                                            <td
                                                                colspan="5"
                                                                class="
                                                                    text-center
                                                                "
                                                            >
                                                                <i
                                                                    >No
                                                                    offer
                                                                    yet</i
                                                                >
                                                            </td>
                                                        </tr>
                                                        <tr
                                                            class="
                                                                border
                                                                border-dashed
                                                            "
                                                        >
                                                            <td
                                                                colspan="4"
                                                                class="
                                                                    text-right
                                                                    py-2
                                                                    px-2
                                                                "
                                                            >
                                                                Total
                                                                RFQ
                                                                Amount:
                                                            </td>
                                                            <td
                                                                colspan="2"
                                                                class="
                                                                    py-2
                                                                "
                                                            >
                                                                {{
                                                                    formatCurrency(
                                                                        getTotalPerPR(
                                                                            x.rfqItems
                                                                        )
                                                                    )
                                                                }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </b-collapse>
                                            <hr />
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    justify-content-between
                                                    cursor-pointer
                                                "
                                                @click="
                                                    getRfqSupplier(x)
                                                "
                                            >
                                                <h5 class="mb-0">
                                                    Suppliers &amp; Offers
                                                </h5>
                                                <h5 class="mb-0">
                                                    <i
                                                        class="
                                                            bx
                                                            bx-chevron-right
                                                            rotate
                                                        "
                                                        :class="{
                                                            'rotate-90':
                                                                x.supplierShow,
                                                        }"
                                                    ></i>
                                                </h5>
                                            </div>
                                            <b-collapse
                                                :visible="x.supplierShow"
                                                :accordion="`supplier-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <hr />
                                                <b-card
                                                    no-body
                                                    class="mb-1 shadow-none"
                                                    v-for="(y, index) in x.rfqSuppliers"
                                                    :key="y.id"
                                                >
                                                    <b-card-header
                                                        header-tag="header"
                                                        role="tab"
                                                        class="border"
                                                        :class="{ 'border-success': y.isWinner }"
                                                    >
                                                        <div
                                                            class="
                                                                d-flex
                                                                justify-content-between
                                                                align-items-center
                                                            "
                                                        >
                                                            <div
                                                                class="
                                                                    d-flex
                                                                    align-items-center
                                                                "
                                                            >
                                                                <div
                                                                    style="
                                                                        min-width: 30px;
                                                                    "
                                                                    class="
                                                                        bg-success
                                                                        bg-gradient
                                                                        text-center
                                                                        me-2
                                                                        py-1
                                                                        position-relative
                                                                    "
                                                                >
                                                                    <h3
                                                                        class="
                                                                            mb-0
                                                                            position-relative
                                                                        "
                                                                    >
                                                                        {{
                                                                            index +
                                                                            1
                                                                        }}
                                                                        <i
                                                                            class="
                                                                                bx
                                                                                bx-crown
                                                                                position-absolute
                                                                                winner-crown
                                                                                font-size-14
                                                                            "
                                                                            v-if="
                                                                                y.isWinner
                                                                            "
                                                                        ></i>
                                                                    </h3>
                                                                </div>
                                                                <div
                                                                    class="
                                                                        text-muted
                                                                    "
                                                                >
                                                                    <h5
                                                                        class="
                                                                            mb-0
                                                                        "
                                                                    >
                                                                        {{
                                                                            y
                                                                                .supplier
                                                                                .name
                                                                        }}
                                                                    </h5>
                                                                    <div
                                                                        style="
                                                                            line-height: 0.8;
                                                                        "
                                                                    >
                                                                        <small
                                                                            >{{
                                                                                y
                                                                                    .supplier
                                                                                    .address
                                                                            }}</small
                                                                        >
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="
                                                                    d-flex
                                                                    align-items-center
                                                                "
                                                            >
                                                                <span
                                                                    v-if="
                                                                        y.isWinner
                                                                    "
                                                                    class="
                                                                        me-5
                                                                    "
                                                                    >Winner</span
                                                                >
                                                                <a
                                                                    href="javascript: void(0);"
                                                                    class="
                                                                        text-success
                                                                        d-flex
                                                                        align-items-center
                                                                    "
                                                                    @click="
                                                                        y.visible =
                                                                            !y.visible
                                                                    "
                                                                >
                                                                    {{
                                                                        y.visible
                                                                            ? "Hide"
                                                                            : "Show"
                                                                    }}
                                                                    Offer
                                                                    <i
                                                                        class="
                                                                            bx
                                                                            bx-chevron-right
                                                                            rotate
                                                                            font-size-14
                                                                        "
                                                                        :class="{
                                                                            'rotate-90':
                                                                                y.visible,
                                                                        }"
                                                                    ></i>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </b-card-header>
                                                    <b-collapse
                                                        :visible="
                                                            y.visible
                                                        "
                                                        :accordion="`posted-supplier-${y.id}`"
                                                        role="tabpanel"
                                                    >
                                                        <table
                                                            class="
                                                                table
                                                                table-bordered
                                                            "
                                                        >
                                                            <thead>
                                                                <tr>
                                                                    <th>
                                                                        Item
                                                                        Name
                                                                        <div>
                                                                            <small
                                                                                >Item
                                                                                Description</small
                                                                            >
                                                                        </div>
                                                                    </th>
                                                                    <th
                                                                        style="
                                                                            width: 120px;
                                                                        "
                                                                    >
                                                                        Unit
                                                                    </th>
                                                                    <th
                                                                        style="
                                                                            width: 70px;
                                                                        "
                                                                    >
                                                                        Qty
                                                                    </th>
                                                                    <th
                                                                        style="
                                                                            width: 150px;
                                                                        "
                                                                    >
                                                                        Unit
                                                                        Cost
                                                                    </th>
                                                                    <th
                                                                        style="
                                                                            width: 150px;
                                                                        "
                                                                    >
                                                                        Total
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr
                                                                    v-for="z in y.supplierRFQ"
                                                                    :key="`poffer-${z.id}`"
                                                                    :class="{
                                                                        'custom-border-2 border-success':
                                                                            z.isWinner,
                                                                    }"
                                                                >
                                                                    <td>
                                                                        {{
                                                                            z.itemName
                                                                        }}
                                                                        <div>
                                                                            <small>
                                                                                {{
                                                                                    z.description
                                                                                }}
                                                                            </small>
                                                                        </div>
                                                                        <div>
                                                                            <p class="mb-0" v-if="z.deliveryPeriod">{{z.deliveryPeriod}} calendar day(s)</p>
                                                                        </div>
                                                                        <div>
                                                                            <a
                                                                                href="javascript:void(0);"
                                                                                :id="`moreSpec${z.id}`"
                                                                                ><i
                                                                                    class="
                                                                                        mdi mdi-triangle
                                                                                        rotate rotate-90
                                                                                        me-1
                                                                                    "
                                                                                ></i
                                                                                >More Specifications</a
                                                                            >
                                                                            <b-popover
                                                                                :target="`moreSpec${z.id}`"
                                                                                triggers="click"
                                                                                placement="right"
                                                                                :show.sync="z.showMoreSpec"
                                                                                custom-class="popover-supplier"
                                                                            >
                                                                                <template v-slot:title>
                                                                                    <div
                                                                                        class="
                                                                                            d-flex
                                                                                            align-items-center
                                                                                            justify-content-between
                                                                                        "
                                                                                    >
                                                                                        <small
                                                                                            >More Specifications</small
                                                                                        >
                                                                                        <span
                                                                                            class="
                                                                                                bx bx-x
                                                                                                font-size-14
                                                                                                cursor-pointer
                                                                                            "
                                                                                            @click="
                                                                                                z.showMoreSpec = false
                                                                                            "
                                                                                        ></span>
                                                                                    </div>
                                                                                </template>
                                                                                <div class="row mb-2">
                                                                                    <div class="col-md-6">
                                                                                        <label for="" class="mb-0"
                                                                                            >Brand</label
                                                                                        >
                                                                                        <div
                                                                                            type="text"
                                                                                            placeholder="Enter Brand"
                                                                                            class="
                                                                                                form-control
                                                                                                form-control-sm
                                                                                            "
                                                                                        >
                                                                                            {{z.brand}}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-md-6">
                                                                                        <label for="" class="mb-0"
                                                                                            >Model</label
                                                                                        >
                                                                                        <div
                                                                                            class="
                                                                                                form-control
                                                                                                form-control-sm
                                                                                            "
                                                                                            
                                                                                        >
                                                                                            {{z.model}}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="row mb-2">
                                                                                    <div class="col-md-6">
                                                                                        <label for="" class="mb-0"
                                                                                            >Color</label
                                                                                        >
                                                                                        <div
                                                                                            class="
                                                                                                form-control
                                                                                                form-control-sm
                                                                                            "
                                                                                        >
                                                                                            {{z.color}}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-md-6">
                                                                                        <label for="" class="mb-0"
                                                                                            >Condition</label
                                                                                        >
                                                                                        <div
                                                                                            class="
                                                                                                form-control
                                                                                                form-control-sm
                                                                                            "
                                                                                        >
                                                                                            {{z.condition}}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="row mb-2">
                                                                                    <div class="col-md-6">
                                                                                        <label for="" class="mb-0"
                                                                                            >Material Used</label
                                                                                        >
                                                                                        <div
                                                                                            class="
                                                                                                form-control
                                                                                                form-control-sm
                                                                                            "
                                                                                        >
                                                                                            {{z.materialUsed}}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-md-6">
                                                                                        <label for="" class="mb-0"
                                                                                            >Package Description</label
                                                                                        >
                                                                                        <div
                                                                                            class="
                                                                                                form-control
                                                                                                form-control-sm
                                                                                            "
                                                                                        >
                                                                                            {{z.packageDescription}}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="mb-2">
                                                                                    <label for="" class="mb-0"
                                                                                        >Dimension Description</label
                                                                                    >
                                                                                    <div
                                                                                        class="
                                                                                            form-control form-control-sm
                                                                                        "
                                                                                    >
                                                                                        {{z.dimensionDescription}}
                                                                                    </div>
                                                                                </div>
                                                                                <div class="mb-2">
                                                                                    <label for="" class="mb-0"
                                                                                        >Other Specifications</label
                                                                                    >
                                                                                    <div
                                                                                        class="
                                                                                            form-control form-control-sm
                                                                                        "
                                                                                    >
                                                                                        {{z.specification}}
                                                                                    </div>
                                                                                </div>
                                                                                <div class="mb-2">
                                                                                    <label for="" class="mb-0"
                                                                                        >Notes</label
                                                                                    >
                                                                                    <div
                                                                                        class="
                                                                                            form-control form-control-sm
                                                                                            text-warning
                                                                                        "
                                                                                    >
                                                                                        {{
                                                                                            z.note
                                                                                        }}
                                                                                    </div>
                                                                                </div>
                                                                            </b-popover>
                                                                        </div>
                                                                    </td>
                                                                    <template v-if="z.offer.noOffer">
                                                                        <td colspan="4" class="text-center align-middle text-warning">
                                                                            Supplier no offer
                                                                        </td>
                                                                    </template>
                                                                    <template v-else>
                                                                        <td>{{ z.unit.unitName }}</td>
                                                                        <td>{{ z.quantity }}</td>
                                                                        <td>{{ formatCurrency(z.unitCost) }}</td>
                                                                        <td>{{ formatCurrency(parseFloat(z.unitCost) * parseFloat(z.quantity)) }}
                                                                            <div class="mt-2"
                                                                                v-if="z.isWinner"
                                                                            >
                                                                                <small class="badge text-warning"><i class="bx bx-crown me-1"></i>Winner</small>
                                                                            </div>
                                                                        </td>
                                                                    </template>
                                                                </tr>
                                                                <tr v-if="y.rfqSupplierOffers.length == 0">
                                                                    <td
                                                                        colspan="5"
                                                                        class="
                                                                            text-center
                                                                        "
                                                                    >
                                                                        <i
                                                                            >No
                                                                            offer
                                                                            yet</i
                                                                        >
                                                                    </td>
                                                                </tr>
                                                                <tr
                                                                    class="
                                                                        border
                                                                        border-dashed
                                                                    "
                                                                >
                                                                    <td
                                                                        class="
                                                                            py-2
                                                                        "
                                                                        colspan="3"
                                                                    >
                                                                        <div>
                                                                            <button
                                                                                type="button"
                                                                                class="btn btn-link"
                                                                                @click="addAttachment(y)"
                                                                            >
                                                                                <i class="mdi mdi-paperclip"></i> Attachments
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                    <td
                                                                        class="
                                                                            text-right
                                                                            py-2
                                                                            px-2
                                                                        "
                                                                    >
                                                                        Total
                                                                        Offer
                                                                        Amount:
                                                                    </td>
                                                                    <td
                                                                        colspan="2"
                                                                        class="
                                                                            py-2
                                                                        "
                                                                    >
                                                                        {{
                                                                            formatCurrency(
                                                                                getTotalOffer(
                                                                                    y.rfqSupplierOffers
                                                                                )
                                                                            )
                                                                        }}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </b-collapse>
                                                </b-card>
                                            </b-collapse>
                                            <hr />
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    justify-content-between
                                                    cursor-pointer
                                                "
                                                @click="x.memberVisible = !x.memberVisible"
                                            >
                                                <div>
                                                    <h5 class="mb-0 text-primary d-flex align-items-center">
                                                        <i
                                                            class="
                                                                bx bx-user-check font-size-18 me-1
                                                            "
                                                        ></i>
                                                        BAC Resolution Members
                                                    </h5>
                                                </div>
                                                <h5 class="mb-0">
                                                    <i
                                                        class="
                                                            bx
                                                            bx-chevron-right
                                                            rotate
                                                        "
                                                        :class="{
                                                            'rotate-90':
                                                                x.memberVisible,
                                                        }"
                                                    ></i>
                                                </h5>
                                            </div>
                                            <b-collapse
                                                :visible="x.memberVisible"
                                                :accordion="`approved-member-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <hr />
                                                <template v-if="x.rfqBacSettings.length == 0">
                                                    <h4 class="text-center">No data found...</h4>
                                                </template>
                                                <template v-if="x.rfqBacSettings.length > 0">
                                                    <template v-for="y in x.rfqBacSettings">
                                                        <div
                                                            class="
                                                                ms-3
                                                                mb-1
                                                                p-3
                                                                broken-border
                                                            "
                                                            :class="{
                                                                'broken-border-success': y.status.toUpperCase() !== 'PENDING'
                                                            }"
                                                            :key="y.id"
                                                        >
                                                            <div
                                                                class="
                                                                    d-flex
                                                                    align-items-center
                                                                    justify-content-between
                                                                "
                                                            >
                                                                <div>
                                                                    <span class="font-weight-bold text-white">{{y.applicationUser ? y.applicationUser.completeName : ''}}</span>
                                                                    <div>
                                                                        <small
                                                                            >{{y.bacName}} {{y.position}}</small
                                                                        >
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="text-center font-weight-bold font-size-18"
                                                                    :class="{
                                                                        'text-warning': y.status.toUpperCase() === 'PENDING',
                                                                        'text-green': y.status.toUpperCase() !== 'PENDING'
                                                                    }"
                                                                >
                                                                        {{y.status.toUpperCase() === 'APPROVED' ? 'DIGITALLY SIGNED': 'PENDING'}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </template>
                                            </b-collapse>
                                            <hr />
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    justify-content-between
                                                    cursor-pointer
                                                "
                                                @click="
                                                    getAttachments(x)
                                                "
                                            >
                                                <h5 class="mb-0 text-warning">
                                                    <i
                                                        class="
                                                            bx
                                                            bx-paperclip
                                                            rotate
                                                            rotate-90
                                                        "
                                                    ></i>
                                                    Attachments
                                                </h5>
                                                <h5 class="mb-0">
                                                    <i
                                                        class="
                                                            bx
                                                            bx-chevron-right
                                                            rotate
                                                        "
                                                        :class="{
                                                            'rotate-90':
                                                                x.attachmentVisible,
                                                        }"
                                                    ></i>
                                                </h5>
                                            </div>
                                            <b-collapse
                                                :visible="
                                                    x.attachmentVisible
                                                "
                                                :accordion="`posted-attachment-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <hr />
                                                <div
                                                    class="
                                                        d-flex
                                                        align-items-center
                                                        justify-content-between
                                                        mb-3
                                                    "
                                                >
                                                    <div class="d-flex">
                                                        <p
                                                            class="mb-0"
                                                            v-if="!x.attachmentLoading &&
                                                                x
                                                                    .rfqFiles
                                                                    .length ==
                                                                0
                                                            "
                                                        >
                                                            <i
                                                                >No
                                                                documents
                                                                found</i
                                                            >
                                                        </p>
                                                        <p
                                                            class="mb-0"
                                                            v-if="
                                                                x.attachmentLoading
                                                            "
                                                        >
                                                            <i class="font-size-15">Loading...</i
                                                            >
                                                        </p>
                                                        <input
                                                            v-if="!x.attachmentLoading &&
                                                                x
                                                                    .rfqFiles
                                                                    .length >
                                                                0
                                                            "
                                                            type="search"
                                                            class="
                                                                form-control
                                                            "
                                                            v-model="
                                                                x.fileSearch
                                                            "
                                                            @input="
                                                                searchDocu(
                                                                    x
                                                                )
                                                            "
                                                            placeholder="Search Documents..."
                                                        />
                                                    </div>
                                                </div>
                                                <div class="mt-2">
                                                    <b-row>
                                                        <b-col
                                                            sm="3"
                                                            v-for="(
                                                                y, index
                                                            ) in searchDocu(
                                                                x
                                                            )"
                                                            :key="y.id"
                                                            class="mb-2"
                                                        >
                                                            <div
                                                                class="
                                                                    position-relative
                                                                    cursor-pointer
                                                                "
                                                                :style="`z-index: ${
                                                                    searchDocu(
                                                                        x
                                                                    )
                                                                        .length -
                                                                    index
                                                                }`"
                                                            >
                                                                <div
                                                                    class="
                                                                        border
                                                                        p-3
                                                                    "
                                                                >
                                                                    <div>
                                                                        <div
                                                                            class="
                                                                                float-end
                                                                                ms-2
                                                                            "
                                                                        >
                                                                            <b-dropdown
                                                                                id="dropdown-dropleft"
                                                                                right
                                                                                variant="link"
                                                                                toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                                                                menu-class="dropdown-menu-end"
                                                                                no-caret
                                                                            >
                                                                                <template
                                                                                    #button-content
                                                                                >
                                                                                    <i
                                                                                        class="
                                                                                            mdi
                                                                                            mdi-dots-horizontal
                                                                                        "
                                                                                    ></i>
                                                                                </template>
                                                                                <b-dropdown-item
                                                                                    @click="
                                                                                        openDocument(
                                                                                            y
                                                                                        )
                                                                                    "
                                                                                    ><i
                                                                                        class="
                                                                                            bx
                                                                                            bx-link-external
                                                                                            me-1
                                                                                        "
                                                                                    ></i
                                                                                    >Open</b-dropdown-item
                                                                                >
                                                                            </b-dropdown>
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                avatar-xs
                                                                                me-3
                                                                                mb-2
                                                                            "
                                                                            @click="
                                                                                openDocument(
                                                                                    y
                                                                                )
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="
                                                                                    avatar-title
                                                                                    bg-transparent
                                                                                    rounded
                                                                                "
                                                                            >
                                                                                <i
                                                                                    v-if="
                                                                                        y.fileType.includes(
                                                                                            'image'
                                                                                        )
                                                                                    "
                                                                                    class="
                                                                                        mdi
                                                                                        mdi-image
                                                                                        font-size-24
                                                                                        text-purple
                                                                                    "
                                                                                ></i>
                                                                                <i
                                                                                    v-if="
                                                                                        y.fileType.includes(
                                                                                            'application'
                                                                                        )
                                                                                    "
                                                                                    class="
                                                                                        mdi
                                                                                        mdi-file-pdf-outline
                                                                                        font-size-24
                                                                                        text-danger
                                                                                    "
                                                                                ></i>
                                                                            </div>
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                d-flex
                                                                            "
                                                                            @click="
                                                                                openDocument(
                                                                                    y
                                                                                )
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="
                                                                                    overflow-hidden
                                                                                    me-auto
                                                                                "
                                                                            >
                                                                                <h5
                                                                                    class="
                                                                                        font-size-14
                                                                                        text-truncate
                                                                                        mb-1
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        y.description
                                                                                    }}
                                                                                </h5>
                                                                                <p
                                                                                    class="
                                                                                        text-muted
                                                                                        mb-0
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        formatDateWithTime(
                                                                                            new Date(
                                                                                                y.dateTimeUploaded
                                                                                            )
                                                                                        )
                                                                                    }}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row
                                                        v-if="
                                                            searchDocu(
                                                                x
                                                            ).length ==
                                                                0 &&
                                                            x.fileSearch
                                                        "
                                                    >
                                                        <b-col
                                                            >Search Not
                                                            Found</b-col
                                                        >
                                                    </b-row>
                                                </div>
                                            </b-collapse>
                                            <hr />
                                            <div>
                                                <button
                                                    type="button"
                                                    class="btn btn-purple me-2"
                                                    @click="printAbstract(x.id)"
                                                >
                                                    <i
                                                        class="
                                                            bx
                                                            bxs-printer
                                                            me-1
                                                        "
                                                    ></i
                                                    >Print Abstract
                                                </button>
                                            </div>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>
                            </div>
                        </div>
                    </div>
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>